<table class="table-responsive table-md">
  <thead>
    <tr>
      @for (column of columnsName; track column) {
        <th>{{ column }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of jsonData; track row) {
      <tr>
        @for (column of columns; track column; let i = $index) {
          <td>
            <span class="responsive-title"> {{ columnsName[i] }}: </span>
            {{ row[column]?.value }}
          </td>
        }
      </tr>
    }
  </tbody>
</table>
